import { Tabs } from "antd";
import React from 'react';
import { useDraggable } from '@dnd-kit/react';
import { callEventChecklistEdit, setChecklistEdit } from "./ChecklistEditContext";
import { ELEMENT_TYPE, elementTypes, IElement, initPropertiesElement } from "./constants";
import styles from "./style.module.scss";

const Element: React.FC<{ data: IElement }> = ({ data }) => {
    const { id, icon, name } = data;
    const { onElementAdd } = callEventChecklistEdit();
    const { ref, isDragging } = useDraggable({
        id: `new-element-${id}`,
        type: 'checklist-new-element',
        data: { elementType: id, name },
    });
    const styleIcon: React.CSSProperties & { '--icon-url': string } = {
        '--icon-url': `url(${icon}) left center no-repeat`
    };

    return <div ref={ref} className={`${styles.leftElement} no-select touch-none !cursor-grab active:!cursor-grabbing ${isDragging ? 'opacity-40' : ''}`}
        title="Drag into the checklist, or click to add a new row"
        onClick={event => {
            if (!event.defaultPrevented) onElementAdd(initPropertiesElement(id), undefined, undefined);
        }}
    >
        <div className={styles.icon} style={styleIcon} />
        <span>{name}</span>
    </div>;
};

const LeftControl: React.FC = () => {
    const set = setChecklistEdit();

    return <div
        className="min-w-[320px] h-full bg-[#B2D2CF]"
        onMouseDown={() => set({ selected: undefined, rowSelected: undefined })}
    >
        <Tabs
            className={styles.leftTabs}
            defaultActiveKey={ELEMENT_TYPE.BASIC}
            tabBarStyle={{ height: '52px' }}
            items={elementTypes.map(item => ({
                label: item.name, key: item.key, children: <div>
                    {item.opts.map(item => <Element data={item} key={item.id} />)}
                </div>
            }))}
        />
    </div>;
};

export default LeftControl;
